export const generateExpenses = {
  businessCompanyNo: '',
  businessDepartmentCode: '',
  contractNo: '', //合同编号
  customerNo: '', //客户名称
  businessCategory: '',
  spaceId: '', //空间资产，
  // spaceIdList: [],
  spaceName: '', //
  // energyCode: '',
  // energyId: '',
  // expenseType: '', //费用类型，
  // leaseDateFrom: '', //开始
  // leaseDateUntil: '', //结束
};
